// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Cambodia from '../_raw/flag/icon_flag_cambodia.png';

export default () => <img src={Cambodia} alt="Cambodia" />;
